import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {Notification} from '../models/notification.model';
import * as moment from 'moment';
import {SystemStoreFacadeService} from '@drl/core/store/system-store-facade.service';
import {environment} from '@drl/env/environment';

@Injectable()
export class NotificationAdapter implements IAdapter<Notification> {
  constructor(private readonly systemStoreFacade: SystemStoreFacadeService) {}

  adaptToModel(resp: any): Notification {
    const notif: Notification = new Notification();
    Object.assign(notif, resp);
    this.systemStoreFacade
      .getLocale()
      .subscribe(locale => moment.locale(locale));
    notif.notificationTime = moment(new Date(notif.sent)).fromNow();
    notif.messageBody = `${notif.body} ${moment(
      new Date(notif.sent),
    ).fromNow()}`;
    notif.messageTitle = notif.subject;
    notif.photo = `assets/${environment.brand.toLocaleLowerCase()}-favicon.ico`; //'/favicon.ico';
    return notif;
  }

  adaptFromModel(data: Notification): any {
    return data;
  }
}
